import { Contract } from "appworks/utils/contracts/contract";
import { AxiosRequestConfig } from "axios";
import { GamevyHTTPConnector } from "./gamevy-http-connector";

export class GamevyOfflineHTTPConnector extends GamevyHTTPConnector {
    protected currentResult = -1;
    protected demoResults: any[] = [];

    public sendRequest(request: any): Contract<{}> {
        const url = (request as AxiosRequestConfig).url;

        const data = this.nextResult();

        if (data) {
            return new Contract<any>((resolve) => {
                resolve({ config: { url }, data });
            });
        } else {
            return super.sendRequest(request);
        }
    }

    public setDemoResults(demoResults: any[]) {
        this.demoResults = demoResults;
        this.currentResult = 0;
    }

    protected nextResult() {
        if (this.currentResult >= 0 && this.currentResult < this.demoResults.length) {
            const data: any = this.demoResults[this.currentResult];
            this.currentResult++;
            if (this.currentResult === this.demoResults.length) {
                this.demoResults = [];
                this.currentResult = -1;
            }
            return data;
        } else {
            return null;
        }
    }
}

export const gamevyOfflineHTTPConnector = new GamevyOfflineHTTPConnector();
